"use strict";

const angular = require("angular");

angular
    .module("ROGER")
    .factory("$messageBox", [
        "$uibModal",
        function ($uibModal) {
            var $messageBox = {};
            // Shows confirm modal window
            $messageBox.showConfirm = function (title, text, buttonText) {
                return $uibModal.open({
                    template: require("./MessageBox.html"),
                    controller: "MessageBoxController",
                    resolve: {
                        title: function () {
                            return title;
                        },
                        text: function () {
                            return text;
                        },
                        buttonText: function () {
                            return buttonText;
                        }
                    }
                });
            };

            return $messageBox;
        }
    ])
    .controller("MessageBoxController", [
        "$scope", "title", "text", "buttonText",
        function ($scope, title, text, buttonText) {

            $scope.title = title;
            $scope.text = text;
            $scope.buttonText = buttonText;

            $scope.buttonClick = function () {
                $scope.$close();
            };
        }
    ]);